import { queryDailyRewardsDetail } from '@/apis/rewards';
import WrappedModal from '@/components/ui/WrappedModal';
import InfoTooltip from '@/components/ui/common/InfoTooltip';
import queryKeysFactory from '@/reactQueryKeys/keysFactory';
import { formatMoneyByCurrency } from '@/utils';
import { ArrowDropDown, Casino, TaskAlt } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import depositIcon from './assets/deposit.png';

import depositAll from './assets/depositAll.png';
import GameWagerTable from './gameWagerTable';

const Wrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2, 1),
  background: theme.palette.bg.main,
  borderRadius: theme.spacing(1),
}));

const DeppositBonusTAndCModal = ({
  open,
  setOpen,
}: // depositBonusInfo,
{
  open: boolean;
  setOpen: (open: boolean) => void;
  // depositBonusInfo: TInferSchemaType<typeof SRewardItem>;
}) => {
  const [t] = useTranslation();

  const { data } = useQuery({
    queryKey: queryKeysFactory.rewards.rewardsDetail(),
    queryFn: () => queryDailyRewardsDetail(),
  });

  const depositBonusInfo = data?.data?.rewards.find(
    (r) => r.bonus === 'DEPOSITBONUS',
  );

  if (!depositBonusInfo) {
    return null;
  }

  const hasOnGoingBonus = depositBonusInfo.currentInProgressIndex > -1;

  return (
    <WrappedModal
      titleComp={
        <Typography
          variant="h4"
          fontSize={'22px'}
          display={'flex'}
          alignItems={'center'}
          gap={1}
        >
          <Image
            src={depositIcon}
            width={25}
            height={25}
            alt={'deposit'}
          ></Image>
          {t('rewards::Welcome Bonus')}
        </Typography>
      }
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Stack gap={1.5}>
        <Image
          src={depositAll}
          alt=""
          style={{
            width: '100%',
            aspectRatio: '1',
            height: 'auto',
          }}
        ></Image>
        {hasOnGoingBonus ? (
          <Box>
            <Typography
              variant="h6"
              display={'flex'}
              alignItems={'center'}
              gap={2}
            >
              <TaskAlt color="disabled" />
              {t('rewards::Activation')}
            </Typography>
            <Wrapper
              gap={2.5}
              sx={{
                fontWeight: 500,
                ['p.MuiTypography-root']: {
                  fontWeight: 'inherit',
                },
              }}
            >
              <Stack direction={'row'} justifyContent={'space-between'}>
                <Typography
                  variant="body1"
                  display={'flex'}
                  alignItems={'center'}
                >
                  {t('rewards::Bonus Amount')}&nbsp;(
                  {
                    ['125%', '150%', '175%', '200%'][
                      Math.min(depositBonusInfo.completedCount, 3)
                    ]
                  }
                  )
                </Typography>
                <Typography>
                  {' '}
                  {formatMoneyByCurrency(depositBonusInfo.bonusAmount, {
                    withCurrencySymbol: true,
                  })}
                </Typography>
              </Stack>

              <Stack direction={'row'} justifyContent={'space-between'}>
                <Typography
                  variant="body1"
                  display={'flex'}
                  alignItems={'center'}
                >
                  {t('rewards::Max. Bonus')}
                  <InfoTooltip
                    text={t(
                      'rewards::The maximum amount of reward you can receive from this Bonus.',
                    )}
                  ></InfoTooltip>
                </Typography>
                <Typography>
                  {formatMoneyByCurrency(depositBonusInfo.maxBonus, {
                    withCurrencySymbol: true,
                  })}
                </Typography>
              </Stack>
              <Stack direction={'row'} justifyContent={'space-between'}>
                <Typography
                  variant="body1"
                  display={'flex'}
                  alignItems={'center'}
                >
                  {t('rewards::Bonus Received')}

                  <InfoTooltip
                    text={t(
                      'rewards::The bonus amount claimed and received so during this Welcome Bonus.',
                    )}
                  ></InfoTooltip>
                </Typography>
                <Typography>
                  {formatMoneyByCurrency(depositBonusInfo.claimedAmount, {
                    withCurrencySymbol: true,
                  })}
                </Typography>
              </Stack>
              <Stack direction={'row'} justifyContent={'space-between'}>
                <Typography
                  variant="body1"
                  display={'flex'}
                  alignItems={'center'}
                >
                  {t('rewards::Bonus Unlocked')}

                  <InfoTooltip
                    text={t(
                      'rewards::The bonus amount unlocked so far for this Welcome Bonus.',
                    )}
                  ></InfoTooltip>
                </Typography>
                <Typography>
                  {formatMoneyByCurrency(depositBonusInfo.availableAmount, {
                    withCurrencySymbol: true,
                  })}
                </Typography>
              </Stack>
              <Stack direction={'row'} justifyContent={'space-between'}>
                <Typography
                  variant="body1"
                  display={'flex'}
                  alignItems={'center'}
                >
                  {t('rewards::Min. Deposit')}
                </Typography>
                <Typography>
                  {formatMoneyByCurrency(depositBonusInfo.minDeposit, {
                    withCurrencySymbol: true,
                  })}
                </Typography>
              </Stack>
              {/* <Stack direction={'row'} justifyContent={'space-between'}>
            <Typography variant="body1" display={'flex'} alignItems={'center'}>
              {t('rewards::Currency')}
            </Typography>
            <Typography>{t('rewards::All Currencies')}</Typography>
          </Stack> */}
            </Wrapper>
          </Box>
        ) : null}
        <Typography variant="h6" display={'flex'} alignItems={'center'} gap={2}>
          <Casino color="disabled" />
          {t('rewards::Wagering')}
        </Typography>
        <Wrapper
          gap={1}
          sx={{
            ['p.MuiTypography-root']: {
              fontSize: '12px',
            },
          }}
        >
          <Typography fontWeight={600} fontSize={'14px !important'} mb={0}>
            {t('rewards::Wager 6x Deposit  Unlocks 10% of Bonus')}
          </Typography>
          <GameWagerTable depositBonusInfo={depositBonusInfo}></GameWagerTable>
          <Accordion>
            <AccordionSummary
              expandIcon={<ArrowDropDown />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography>{t('rewards::Example 1')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{t('rewards::Player deposits $100.')}</Typography>
              <Typography>
                {t('rewards::Welcome Bonus = $100 (Deposit $100 x 100%)')}
              </Typography>
              <Typography color={'text.secondary'}>
                {t('rewards::*Bonus is paid in 10 instalments.')}
              </Typography>
              <br />
              <Typography>
                {t(
                  'rewards::Wager Requirements for each bonus release = $600 (Deposit $100 x 6)',
                )}
              </Typography>
              <br />
              <Typography>
                {t(
                  'rewards::Player wagered $660 on any of the slot games. Wager progression = $660 ( $660 x 100% Slots Wagering Contribution %)',
                )}
              </Typography>
              <Typography>
                {t(
                  'rewards::Welcome Bonus of $10 will be available to claim (10% of $100 Welcome Bonus).',
                )}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion>
            <AccordionSummary
              expandIcon={<ArrowDropDown />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography>{t('rewards::Example 2')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{t('rewards::Player deposits $50.')}</Typography>
              <Typography>
                {t('rewards::Welcome Bonus = $50 (Deposit $50 x 100%)')}
              </Typography>
              <Typography color={'text.secondary'}>
                {t('rewards::*Bonus is paid in 10 instalments.')}
              </Typography>
              <br />
              <Typography>
                {t(
                  'rewards::Wager Requirements for each bonus release = $300 (Deposit $50 x 6)',
                )}
              </Typography>
              <br />
              <Typography>
                {t('rewards::Player wagered $420 on Crash game.')}
              </Typography>
              <Typography>
                {t(
                  'rewards::Wager progression = $21 ( $420 x 5% Crash Game Wagering Contribution %).',
                )}
              </Typography>
              <Typography>
                {t(
                  'rewards::Welcome Bonus of $5 (10% of $50 Welcome Bonus)will not be unlocked. The player needs to wager on game categories that offers higher contribution.',
                )}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion>
            <AccordionSummary
              expandIcon={<ArrowDropDown />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography>
                {t('rewards::Welcome Bonus Terms and Conditions')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                display: 'flex',
                gap: 0.5,
                flexDirection: 'column',
              }}
            >
              <Typography>
                {t(
                  'rewards::1. Welcome bonus can only be claimed on your first deposit.',
                )}
              </Typography>
              <Typography>
                {t(
                  'rewards::2. You must make a deposit of $20 or more to claim this bonus.',
                )}
              </Typography>
              <Typography>
                {t(
                  'rewards::3. The maximum you can cash out from the bonus as real money is capped at $2,000.',
                )}
              </Typography>

              <Typography>
                {t(
                  'rewards::4. The bonus comes attached to a 60x wagering requirement.',
                )}
              </Typography>

              <Typography>
                {t(
                  'rewards::5. The wagering requirements must be fulfilled within 14 days or the bonus and any winnings will become void.',
                )}
              </Typography>
              <Typography>
                {t(
                  'rewards::6. The bonus wagering contribution is as follows – Slots: 100%, Roulette: 5%, Crash Games: 5%, Other Games: 20%.',
                )}
              </Typography>
              <Typography>
                {t(
                  'rewards::7. MoonClub reserves the right to update/change the promotion without notice.',
                )}
              </Typography>
              <Typography>
                {t(
                  'rewards::8. MoonClub’s General Terms and Conditions apply.',
                )}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Wrapper>
      </Stack>
    </WrappedModal>
  );
};

export default DeppositBonusTAndCModal;
